import React from 'react';
import { Link } from 'react-router-dom';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import { Genre } from 'rebook/apps/catalog/models';
import TagLabel from 'rebook/apps/base/components/TagLabel';

import LandingContentContainer from '../LandingContentContainer';


const BusinessBooksBlock = ({ businessBookset, businessBooksetModel, genres }) => (
  <div className="billetContainerNoOverflow">
    <div className="billetContainerWrapper">
      <LandingContentContainer
        link={businessBooksetModel && businessBooksetModel.getLink()}
        title="Бизнес и саморазвитие"
        linkText="Все бизнес-книги" />
      <p>Деловая и научно-популярная литература издательств «Манн, Иванов и Фербер»,
        «Альпина Паблишер», «Олимп-Бизнес» и других
      </p>
      {genres && (
        genres.map((item, key) => {
          const genre = new Genre(item);
          return (
            <Link to={genre.getLink()} key={key}>
              <TagLabel name={genre.name} />
            </Link>
          );
        })
      )}
    </div>
    <VerticalBookCardList bookList={businessBookset && businessBookset.books} />
  </div>
);

export default BusinessBooksBlock;
